let React               = require("react");

let ContentServerClient = require("../../../ContentServerClient.js");
let WrappedModalHub     = require("./WrappedModalHub.jsx");
let Utilities =           require("../../../util/Utilities.js");

const RegionUtil = require("../../../util/RegionUtil.js");
const ApplicationContext = require("../../../config/ApplicationContext.js");

class CreateModalHub extends React.Component {

    constructor(){
        super();

        this.state = { regions: {}, selectedRegion: ApplicationContext.getCurrentRegion() };
        this.createHub = this.createHub.bind(this);
        this.onHubSelected = this.onHubSelected.bind(this);
        this.checkSpecialCharacters = this.checkSpecialCharacters.bind(this);
        this.onRegionChange = this.onRegionChange.bind(this);
    }

    componentDidMount(){
        RegionUtil.getRegions().then(regions => this.setState({ regions: regions }));
    }

    shouldComponentUpdate(nextProps, nextState){
        return  nextProps.show !== this.props.show
            || nextProps.hubCounts !== this.props.hubCounts
            || nextState.selectedRegion !== this.state.selectedRegion
            || nextState.regions !== this.state.regions
    }

    onRegionChange(e){
        this.setState({ selectedRegion: e.target.value });
    }

    onHubSelected(id, name, region){
      if (region) {
        ApplicationContext.setCurrentRegion(region);
        Utilities.setCookie(`lastHubRegion=${region}`);
      }
      this.props.history.push(`/hubs/${id}-${encodeURIComponent(name)}/libraries`);
    }

    createHub(){
        let {onClose, setLoading, handleError} = this.props;

        if(this.name.value === "" || Utilities.hasSpecialCharacters(this.name.value)){return}

        setLoading(true, `Creating hub ${this.name.value}...`);

        const region = this.state.selectedRegion || ApplicationContext.getCurrentRegion();

        ContentServerClient.createHub(handleError, this.name.value, region)
            .then(hub => {
                setLoading(false);
                onClose("create");
                this.onHubSelected(hub.id, hub.name, region);
            })
            .catch(error => setLoading(false));
    }

    componentDidUpdate(prevProps){
        if(prevProps.show !== this.props.show && this.props.show){
          if(this.name){ this.name.value = "" }
          const initial = this.pickInitialRegion();
          if(this.state.selectedRegion !== initial){ this.setState({ selectedRegion: initial }) }
        }
    }

    canCreateHubs(regionId){
        const counts = this.props.hubCounts && this.props.hubCounts.countsByRegion;
        const c = counts && counts[regionId];
        return !!c && c.currentNumberOfHubs < c.allowedNumberOfHubs;
    }

    // Prefer the user's current region; if it's full, fall back to the first
    // region that still has room so the modal opens ready to create somewhere.
    pickInitialRegion(){
        const current = ApplicationContext.getCurrentRegion();
        if(this.canCreateHubs(current)) return current;
        const withRoom = Object.keys(this.state.regions || {}).find(r => this.canCreateHubs(r));
        return withRoom || current;
    }

    checkSpecialCharacters(){
         if(Utilities.hasSpecialCharacters(this.name.value)){
             this.name.classList.add("invalid")
         }else{
             this.name.classList.remove("invalid")
         }
    }

    render() {

        const {onClose, show, hubCounts:{ allowedNumberOfHubs, currentNumberOfHubs, countsByRegion}} = this.props;
        const doneLoading = allowedNumberOfHubs != -1;

        const { regions } = this.state;
        const regionIds = Object.keys(regions);
        const showRegionDropdown = regionIds.length > 1;
        const currentRegion = ApplicationContext.getCurrentRegion()

        const selectedRegion = this.state.selectedRegion || currentRegion;
        const counts = (countsByRegion && countsByRegion[selectedRegion]) || { allowedNumberOfHubs, currentNumberOfHubs };
        const createMore = counts.currentNumberOfHubs < counts.allowedNumberOfHubs;
        const allowedHubs = counts.allowedNumberOfHubs - counts.currentNumberOfHubs;

        // The hard "you cannot create more" block should only show when every
        // region is full - if any region has room the user can switch to it.
        const hasRoom = r => { const c = countsByRegion && countsByRegion[r]; return !!c && c.currentNumberOfHubs < c.allowedNumberOfHubs; };
        const canCreateAnywhere = countsByRegion ? regionIds.some(hasRoom) : createMore;

        return  <WrappedModalHub show={show} style="fifty" title={`New ${fullHubAlias}`}
                    btnBlue={{show: true, text: "Create", disable: createMore? "false": "true",
                                onClick: createMore? this.createHub: null}}
                    onClose={() => onClose("create")}
                >
                { doneLoading &&
                    <div className="createModalHub">
                        {canCreateAnywhere ? <React.Fragment>
                            {createMore &&
                                <div className="createModalHub__contName">
                                    <p className="bold">{hubAlias} Name:</p>
                                    <input type="text" onChange={this.checkSpecialCharacters} ref={div => this.name = div}/>
                                    <p className="warning">Special characters are not allowed.</p>
                                </div>}

                            {showRegionDropdown && <React.Fragment>
                                <div className="clear"></div>
                                <div className="createModalHub__contName">
                                    <p className="bold">{hubAlias} Region:</p>
                                    <select value={selectedRegion} onChange={this.onRegionChange}>
                                        {regionIds.map(r => <option key={r} value={r}>{r.toUpperCase()}</option>)}
                                    </select>
                                </div>
                            </React.Fragment>}

                            <div className="clear"></div>
                            {createMore
                                ? <p>You can create up to <span className="bold">{allowedHubs}</span> more {fullHubAlias}{(allowedHubs != 1) ? "s" : ""} on your account.</p>
                                : <p>You've reached the maximum number of {fullHubAlias}s in this region. Select another region to create one.</p>}
                          </React.Fragment>
                        : <p>You cannot create more than <span className="bold">{counts.allowedNumberOfHubs}</span> hubs.</p>}
                    </div>
                }
                { !doneLoading &&
                    <p>Loading...</p>
                }
                </WrappedModalHub>
    }
}

module.exports = CreateModalHub;
